import { useAuth0 } from "@auth0/auth0-react"
import { useCallback } from "react"

const VITE_MBLS_IDP_URL = import.meta.env.VITE_MBLS_IDP_URL

export const useFetchIdp = () => {
  const { getAccessTokenSilently } = useAuth0()

  return useCallback(
    async (endpoint: string, options: RequestInit = {}) => {
      try {
        const token = await getAccessTokenSilently({
          authorizationParams: {
            audience: "mbls-global-api",
          },
        })

        // remove the leading slash from the endpoint
        // to avoid double slashes in the URL
        const formattedEndpoint = endpoint.startsWith("/")
          ? endpoint.slice(1)
          : endpoint

        const response = await fetch(`${formattedEndpoint}`, {
          ...options,
          headers: {
            ...options.headers,
            ts: Date.now().toString(),
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        })

        if (!response.ok) {
          console.error("Fetch failed with status:", response.status)
        }

        return response
      } catch (error) {
        console.error("Error fetching from IDP:", error)
        throw error
      }
    },
    [getAccessTokenSilently],
  )
}
